import { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { useAuth } from "@/contexts/AuthContext";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Card, CardHeader, CardTitle, CardDescription, CardContent, CardFooter } from "@/components/ui/card";
import { Trees } from "lucide-react";
import { toast } from "sonner";
import { useSiteSettings } from "@/contexts/SettingsContext";
import BrandLogo from "@/components/BrandLogo";

export default function LoginPage() {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);
  const { login } = useAuth();
  const navigate = useNavigate();
  const { settings } = useSiteSettings();
  const tagline = settings?.login_tagline || (settings?.app_name ? `Connectez-vous a votre compte ${settings.app_name}` : "Connectez-vous a votre compte");

  const handleSubmit = async (e) => {
    e.preventDefault(); setLoading(true);
    try { await login(email, password); toast.success("Connexion reussie"); navigate("/"); }
    catch (err) { toast.error(typeof err.response?.data?.detail === "string" ? err.response.data.detail : "Identifiants invalides"); }
    finally { setLoading(false); }
  };

  return (
    <div className="min-h-[calc(100vh-4rem)] flex items-center justify-center px-4 py-12">
      <Card className="w-full max-w-md border border-zinc-200 rounded-2xl shadow-sm animate-fade-in" data-testid="login-card">
        <CardHeader className="text-center">
          <div className="mx-auto mb-2 flex items-center justify-center"><BrandLogo size="md" /></div>
          <CardTitle className="font-heading text-2xl font-bold">Connexion</CardTitle>
          <CardDescription>{tagline}</CardDescription>
        </CardHeader>
        <CardContent>
          <form onSubmit={handleSubmit} className="space-y-4" data-testid="login-form">
            <div><Label htmlFor="email">Email</Label><Input id="email" type="email" value={email} onChange={(e) => setEmail(e.target.value)} placeholder="votre@email.com" required className="mt-1" data-testid="login-email-input" /></div>
            <div><Label htmlFor="password">Mot de passe</Label><Input id="password" type="password" value={password} onChange={(e) => setPassword(e.target.value)} placeholder="Votre mot de passe" required className="mt-1" data-testid="login-password-input" /></div>
            <Button type="submit" className="w-full bg-emerald-700 text-white hover:bg-emerald-800 rounded-xl" disabled={loading} data-testid="login-submit-btn">{loading ? "Connexion..." : "Se connecter"}</Button>
            <div className="text-center">
              <Link to="/forgot-password" className="text-sm text-emerald-600 hover:underline" data-testid="forgot-password-link">Mot de passe oublié?</Link>
            </div>
          </form>
        </CardContent>
        <CardFooter className="justify-center"><p className="text-sm text-zinc-500">Pas encore de compte? <Link to="/register" className="text-emerald-600 hover:underline font-medium" data-testid="goto-register-link">S'inscrire</Link></p></CardFooter>
      </Card>
    </div>
  );
}
